import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'angular-main',
    templateUrl: 'app.component.html',
    styleUrls: ['style.scss', 'app.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {

    private language: string;
    private showFooter = true;

    constructor(translate: TranslateService,
                private cookieService: CookieService) {
        // The website renders <base href="/de/"> etc. for each language URL; it stopped setting
        // the i18n cookie in 2021, so the cookie is only a fallback (e.g. standalone index.html)
        const baseHref = document.querySelector('base')?.getAttribute('href') ?? '';
        const pageLocale = baseHref.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\/$/)?.[1];
        this.language = pageLocale || this.cookieService.get('i18n');
        if (this.language != null && this.language != undefined && this.language.length > 0) {
            //  // the lang to use, if the lang isn't available, it will use the current loader to get them
            translate.use(this.language);
        }
    }

    ngOnInit() {
    }

    onNotification(event: string) {
        if (event === 'Result') {
            this.showFooter = false;
        }
        if (event === 'Test') {
            this.showFooter = true;
        }
    }

}
